import { object, string, date } from 'yup';

export default object().shape({
  firstName: string().required('First name is required'),
  lastName: string().required('Last name is required'),
  phone: string()
    .required('Phone number is required')
    .matches(
      /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
      'Phone number should be XXX-XXX-XXXX format'
    ),
  email: string().email('Invalid email address'),
  birthday: date(),
});
